import {getCurrentUser} from "../../utils/user";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { UserSessionState } from "../../stores/UserSessionState";
import {queryGqlApi} from "../../graphql/queryGqlApi";
import {updateClientUser} from "../../graphql/mutations";


export const saveAvatarPath = async (
    services: CrudServices,
    userState: UserSessionState,
    avatarPath: string
) => {
    const user = await getCurrentUser(services.authService);
    if (!user) {
        return;
    }
    
    await updateUserInDB(services, userState, {
        avatarPath: avatarPath
    });
}


export const removeAvatarPath = async (
    services: CrudServices,
    userState: UserSessionState
) => {
    const user = await getCurrentUser(services.authService);
    if (!user) {
        return;
    }
    
    await updateUserInDB(services, userState, {
        avatarPath: null
    });
}


export interface UserUpdateObject {
    avatarPath?: string | null;
    email?: string;
    address?: string;
    family_name?: string;
    name?: string;
    phone_number?: string;
    utm?: string;
}

export type UserUpdateApiObject = Omit<UserUpdateObject, 'family_name' | 'phone_number'> & {
    surname?: string;
}

export const updateCurrentUserWithCognito = async (
    services: CrudServices,
    userState: UserSessionState,
    updatedAttributes: UserUpdateObject
) => {
    const currentUserDb = userState.currentUserDb;
    if (!currentUserDb) {
        throw new Error('Current user not found in database');
    }
    
    await services.authService.updateUserAttributes(updatedAttributes as any);
    
    const {family_name, phone_number, ...dbUpdateAttributes} = updatedAttributes;
    if (family_name !== undefined) {
        (dbUpdateAttributes as UserUpdateApiObject).surname = family_name;
    }
    
    await updateUserInDB(services, userState, dbUpdateAttributes);
}

export const changePasswordCurrentUser = async (
    services: CrudServices,
    oldPassword: string,
    newPassword: string
) => {
    return services.authService.updatePassword(oldPassword, newPassword);
}

export const updateUserInDB = async (
    services: CrudServices,
    userState: UserSessionState,
    updatedAttributes: UserUpdateApiObject
) => {
    const currentUserDb = userState.currentUserDb;
    if (!currentUserDb) {
        throw new Error('Current user not found in database');
    }
    
    return queryGqlApi(
        updateClientUser,
        {
            input: {
                id: userState.currentUserId,
                ownerId: userState.tenantId,
                _version: currentUserDb._version,
                ...updatedAttributes,
            }
        },
        services.dataClientService,
        services.authService,
        'main'
    );
}
